import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  getTableColumnNames,
  getSubscriptionAPI,
  addSubscriptionAPI,
  updateSubscriptionAPI,
  deleteSubscriptionAPI,
  activateDeactivateSubscriptionAPI,
  getSubscriptionTagsAPI
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Subscription Table Column Names
export const fetchSubscriptionTableColumnNames = createAsyncThunk(
  "subcriptions/fetchSubscriptionTableColumnNames",
  async (subscription, thunkAPI) => {
    try {
      const response = await getTableColumnNames(subscription);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Fetch Subscription
export const fetchSubscription = createAsyncThunk(
  "subcriptions/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSubscriptionAPI();
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching subscription");
    }
  }
);

// Add Subscription
export const addSubscription = createAsyncThunk(
  "subcriptions/add",
  async (subscription, { rejectWithValue }) => {
    try {
      const response = await addSubscriptionAPI(subscription);
        toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error adding subscription");
    }
  }
);

// Update Subscription
export const updateSubscription = createAsyncThunk(
  "subcriptions/update",
  async (subscription, { rejectWithValue }) => {
    try {
      const response = await updateSubscriptionAPI(subscription);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error updating subscription");
    }
  }
);

// Delete Subscription
export const deleteSubscription = createAsyncThunk(
  "subcriptions/delete",
  async (subscription, { rejectWithValue }) => {
    try {
      const response = await deleteSubscriptionAPI(subscription);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error deleting subscription");
    }
  }
);

// Active Deactive Subscription
export const activateDeactivateSubscription = createAsyncThunk(
  "subcriptions/activateDeactivate",
  async (subscription, { rejectWithValue }) => {
    try {
      const response = await activateDeactivateSubscriptionAPI(subscription);      
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error activating/deactivating subscription");
    }
  }
);

// Fetch Features
export const fetchSubscriptionTags = createAsyncThunk(
  "subcriptions/fetchSubscriptionTags",
  async (subscription, { rejectWithValue }) => {
    try {
      const response = await getSubscriptionTagsAPI(subscription);      
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error activating/deactivating subscription");
    }
  }
);